import createStore from "@Stores/base-factories";
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection";
import { hookGlobalGetTemplates } from "@Stores/global/factory";

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('cms/snippet')
  .extendHookCollectionsFactory('cms/snippets')
  .extend(hookGlobalGetTemplates('cms/setting'))
  .factory()

export {
  Provider as SnippetProvider,
  useStore as useSnippetStore,
}
